import List from '@/utils/list'
const { Search, Table, Jurisdiction, Tabs, Operation } = List
import { $t } from '@plugin/i18n'
import { downLoad, release, start, stop } from './config/index'
import http from '@plugin/axios'

const search = new Search('data.data')
  .placeholder('placeholder')
  .add('addUserName')
  .lib('dateTimeRange').prop(['startReleaseTime', 'endReleaseTime']).label('dateRange')

const tabOptions = [{ name: $t('data.data.tabOptions[0]'), status: '0' }, { name: $t('data.data.tabOptions[1]'), status: '1' }, { name: $t('data.data.tabOptions[2]'), status: '2' }, { name: $t('data.data.tabOptions[3]'), status: '3' }]
const tabs = new Tabs()
  .api(() => Promise.resolve(tabOptions))
  .map({ '0': '' })

const jurisdiction = new Jurisdiction()
  .lib('add').to('Data.Data.Add')
  .lib('modify').modify('Data.Data.Modify')
  .lib('delete').del('/srmData/deleteDataByIds', process.env.VUE_APP_BASE_DATA_API)

const table = new Table('data.data')
  .add('status').name('statusName')
  .add('dataNo')
  .add('dataName')
  .add('fileType').format(({ value }) => value === '1' ? $t('data.data.fileTypeOptions[0]') : $t('data.data.fileTypeOptions[1]'))
  .add('fileVersion')
  .add('releaseTime').tooltip()
  .add('addUserName')
  .add('addDeptName')

const operation = new Operation('data.data.handleOptions')
  .width(200)
  .add('release').handle(release).show((row) => row.releaseStatus === '0')
  .add('start').handle(start).show((row) => row.releaseStatus === '1' && row.status === '2')
  .add('stop').handle(stop).show((row) => row.releaseStatus === '1' && row.status === '1')
  .add('sendRecord').to('Data.Data.SendRecord', row => ({ id: row.id })).show((row) => row.releaseStatus === '1')
  .add('downLoad').handle(downLoad)

const getStatus = function(key = ''): object {
  const obj = {
    releaseStatus: '',
    status: ''
  }
  switch (key) {
    case '1':
      obj.releaseStatus = '1'
      obj.status = '1'
      break
    case '2':
      obj.releaseStatus = '0'
      obj.status = ''
      break
    case '3':
      obj.releaseStatus = '1'
      obj.status = '2'
      break
  }
  return obj
}

function api(data: any): Promise<any> {
  const params = {
    ...data,
    condition: {
      ...data.condition,
      ...getStatus(data.condition.status)
    }
  }
  return http({ url: '/srmData/getDataPage', baseURL: process.env.VUE_APP_BASE_DATA_API, data: params })
}

export default new List()
  .api(api)
  .jurisdiction(jurisdiction)
  .search(search)
  .tabs(tabs)
  .table(table)
  .operation(operation)
  .end()
